import { usePublicSettings } from "@/hooks/useSettings";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const DEFAULT_IMAGE = "/dojo-guide-default.png";

// The single source of truth for the Wise Mentor "Guide" — name + portrait —
// pulled from public settings so every surface stays in sync with the Admin
// Dojo Guide control. Falls back to the bundled default portrait.
export function useGuide() {
  const { data } = usePublicSettings();
  const g = data?.guide || {};
  const name = g.name || "Donnyllama";
  const raw = g.image_url || "";
  const image = raw ? (raw.startsWith("/api") ? `${BACKEND}${raw}` : raw) : DEFAULT_IMAGE;
  return { name, image };
}
